import Vue from 'vue'

import router from '@/router'
import { api, endpoints } from '@/api'

const state = {
  loginProbePromise: null,
  isLoggedIn: false,
  user: null,
  tenantLoginBackend: {},
}

const getters = {
  username: state => state.user ? state.user.username : '',
  userid: state => state.user ? state.user.pk : '',
  employee: state => {
    if (state.user && state.user.employee) {
      return state.user.employee
    } else {
      return null
    }
  },
  isSuperuser: state => state.user && state.user.is_superuser,
  isLoggedIn: state => state.isLoggedIn,
  userDisplayName: state => {
    if (state.user) {
      return state.user.name || `${state.user.first_name} ${state.user.last_name}`
    } else {
      return ''
    }
  },
  loginProbePromise: state => state.loginProbePromise,
}

const actions = {
  async probeLogin ({commit}) {
    const loginProbePromise = (async () => {
      try {
        const r = await api(endpoints.probeLogin(), {})
        if (r.ok) {
          const user = await r.json()
          commit('loginSuccessful', {user})
          const profile = (user && user.employee) ? user.employee.profile : null
          commit('updateProfile', {profile})
        } else {
          commit('logoutSuccessful')
        }
      } catch (err) {
        console.log('probeLogin failed', err)
      }
    })()
    commit('setLoginProbePromise', {loginProbePromise: loginProbePromise})
  },
  async login ({commit, state}, {username, password, rememberMe, successRedirect}) {
    try {
      const r = await api(endpoints.login(), {username, password, rememberMe})
      if (r.ok) {
        const user = await r.json()
        commit('loginSuccessful', {user})
        const profile = user.employee.profile
        commit('updateProfile', {profile})
        if (successRedirect) {
          router.push(successRedirect)
        }
        return {success: true, response: r}
      } else {
        commit('loginError')
        const result = {success: false, response: r}
        if (r.status === 400) {
          // invalid credentials
          result.invalid_credentials = true
        }
        return result
      }
    } catch (err) {
      commit('loginError')
      return {success: false, response: null, error: err}
    }
  },
  async logout ({commit, state}) {
    if (this.getters.isLoggedIn) {
      const r = await api(endpoints.logout(), {})
      if (r.ok) {
        commit('logoutSuccessful')
        return true
      }
    }
  },
  async checkLoginTenant({commit}, {tenantLoginIdentifier}) {
    const r = await api(endpoints.checkLoginTenant(), {tenant_login_identifier: tenantLoginIdentifier})
    if (r.ok) {
      const tenantInfo = await r.json()
      commit('rememberLoginTenantBackendOptions', {
        tenantInfo: tenantInfo,
        tenantLoginIdentifier: tenantLoginIdentifier
      })
      commit('saveLoginTenant', {loginTenant: tenantLoginIdentifier})
      return {
        success: true,
        tenantInfo: tenantInfo,
      }
    } else {
      // combines all errors from all fields into one array
      const errors = Object.values(await r.json()).reduce((results, item) => [...results, ...item], [])
      return {
        success: false,
        errors,
      }
    }
  },
  getTenantLoginBackendInfo ({state}, {tenantLoginIdentifier}) {
    return state.tenantLoginBackend[tenantLoginIdentifier] || null
  },
}

const mutations = {
  loginSuccessful (state, {user, successRedirect}) {
    state.user = user
    state.isLoggedIn = true
    if (successRedirect) {
      router.push(successRedirect)
    }
  },
  loginError (state) {
    state.isLoggedIn = false
  },
  logoutSuccessful (state) {
    state.isLoggedIn = false
    state.user = null
  },
  rememberLoginTenantBackendOptions (state, {tenantLoginIdentifier, tenantInfo}) {
    Vue.set(state.tenantLoginBackend, tenantLoginIdentifier, tenantInfo)
  },
  setLoginProbePromise (state, {loginProbePromise}) {
    state.loginProbePromise = loginProbePromise
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}
